module.exports = __webpack_public_path__ + "static/img/lacan1.080a3db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lacan1.jpg
// module id = 553
// module chunks = 2